import {
  FieldsModalController
} from './fields-modal.component';

export class FieldsModalService {
  constructor(
    $timeout,
    $modal,
    RouterService,
  ) {
    this.router = RouterService;
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  // purpose = 'CSV' - for CSV export collumns selection
  // purpose = 'TABLE' - for facts table view collumns selection
  open(purpose, settingKey) {
    return this.$modal.open({
      template: require('./fields-modal.component.html'),
      controller: FieldsModalController,
      resolve: {
        purpose: () => purpose,
        settingKey: () => settingKey,
      },
    }).result;
  }
}



// WEBPACK FOOTER //
// ./src/layout/fields/fields-modal.service.js